// src/lib/exportPermission.ts
//
// Who sees «Exportar» on a screen. The roles listed for the screen always do. A Viewer does too
// when the server grants the `export` capability (`GET /api/v1/ui/users/me`: some chain of the
// user has «Los lectores pueden exportar» on), and only on the screens open to customer exports
// (those that list HotelAdmin). Receptionist never exports. Same rule as the server's
// CsvExportAuthorization.

export const canExportWith = (
  role: string | null | undefined,
  allowedRoles: readonly string[] | undefined,
  capabilities: readonly string[]
): boolean => {
  if (!role || !allowedRoles) return false;
  if (allowedRoles.includes(role)) return true;
  return role === 'Viewer' && capabilities.includes('export') && allowedRoles.includes('HotelAdmin');
};
